module.exports = __webpack_public_path__ + "img/nube.19868256.png";